import { API_STATES } from "@/helpers";

const state = {
  calendarEventsGetState   : API_STATES.NOT_REQUESTED,
  calendarEventsGetError   : null,
  calendarEvents           : [],
  calendarEventCreateState : API_STATES.NOT_REQUESTED,
  calendarEventCreateError : null,
  calendarEventUpdateState : API_STATES.NOT_REQUESTED,
  calendarEventUpdateError : null,
  calendarEvent            : {},
  calendarEventDeleteState : API_STATES.NOT_REQUESTED,
  calendarEventDeleteError : null,
};

export default state;